import {
  TransactionModalInput,
  TransactionModalMode,
} from '../model/single-transaction/popup-input.model'
import { RequestMode } from '../model/validation-response.model'

/**
 * Get transaction request mode from modal mode.
 */
export function getRequestModeFromModalMode(
  transInput: TransactionModalInput | undefined,
  isExternalAvailable: boolean = true,
): RequestMode {
  if (!transInput) {
    return RequestMode.NEW_TRAN
  }

  switch (transInput.modalMode) {
    case TransactionModalMode.EditCWTran:
      return RequestMode.EDIT_TRAN
    case TransactionModalMode.CreateFromExtTran:
      return isExternalAvailable
        ? RequestMode.ENTER_EXTERNAL_TRAN
        : RequestMode.NEW_TRAN
    case TransactionModalMode.CreateCWTran:
      return RequestMode.NEW_TRAN
    case TransactionModalMode.CreateFromPosition:
      return RequestMode.NEW_TRAN
  }
}
